export const articleLink = (id, title) => {
    const linkifiedTitle = title.toLowerCase().split('')
        .map(char => /[a-z0-9]/.test(char) ? char : '-') // only characters allowed are letters, numbers and hyphen
        .filter((char, index, array) => !(array[Math.max(index - 1, 0)] === '-' && char === '-')) // remove duplicate hyphens
        .filter((char, index, array) => !(index === array.length - 1 && char === '-')) // remove hyphen at the end
        .join('');

    return `${linkifiedTitle}-${id}`;
}